import { Component, Input, OnInit, Output, EventEmitter, ViewChild, OnChanges, ViewEncapsulation, ViewChildren, QueryList, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { FormFields } from 'app/views/campaign-3/components/form-fields/form-fields.component';
import { Campaign3Wizard } from 'app/views/campaign-3/models/campaign-3-touchpoint.model';
import { CertificationTouchpointList } from 'app/views/campaign-3/models/campaign-3-validation.model';
import { Campaign3StatusMapping, Campaign3Info, MessageInstanceObject, Campaign3ActionStatus, JsonSchema, DistributionListCluster, Touchpoint, MessageInstanceRule, MessageInstanceRuleTypes, MessageInstanceObjectTypes, MessageInstanceRuleDetail } from 'app/views/campaign-3/models/campaign-3.model';
import { Campaign3Service } from 'app/views/campaign-3/services/campaign3.service';
import { MessageService } from 'primeng/primeng';



@Component({
  selector: 'app-message-3-validations',
  templateUrl: './message-3-validations.component.html',
  styleUrls: ['./message-3-validations.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Message3ValidationsComponent implements OnInit, OnDestroy {

  disable = {
    generaCouponPreview: false,
    generaDefinitiviRichiediPubblicazioni: false,
    annullaPubblicazione: false,
    aggiornaAzione: false,
    pubblicaNuovamente: false
  }

  @Input() actionTypeCode: string = "";
  @Input() statusMapping: Campaign3StatusMapping;
  @Input() campaignInfo: Campaign3Info = null;
  @Input() ui_mode: string = this.srvCampaign3.ui_modes.CREATE;
  @Input() coupon_mode: string = this.srvCampaign3.coupon_modes.CREATE;
  @Input() formSchema: any;
  @Input() messageInstanceObject: MessageInstanceObject;
  @Input() readOnly: boolean = false;
  @Input() statusList: Array<Campaign3ActionStatus> = [];
  @Output() messageInstanceObjectChange: EventEmitter<MessageInstanceObject> = new EventEmitter<MessageInstanceObject>();
  @Output() formSchemaChanged: EventEmitter<JsonSchema> = new EventEmitter<JsonSchema>();


  certificationTouchpointList: CertificationTouchpointList = new CertificationTouchpointList();

  certificationInfo = {
    needsCertification: false, //utilizzato per sapere se c'è almeno un touchpoint certificatore
    isCertificated: false, //utilizzato quando esiste almeno un touchpoint certificatore, indica se tutti i touchpoint certificatori hanno certificato
    loaded: false
  }

  valid: boolean = true;

  show = {
    form: false,
    generaCouponPreview: false,
    generaDefinitiviRichiediPubblicazioni: false,
    annullaPubblicazione: false,
    aggiornaAzione: false,
    modalCoupon: false,
    modalWizard: false,
    pubblicaNuovamente: false
  }

  @Input() distributionListEmission: Array<DistributionListCluster> = [];
  /*   @Input() distributionListFruition: Array<DistributionListCluster> = []; */
  @Input() accumulatorListEmission: Array<any> = [];
  /*   @Input() accumulatorListFruition: Array<any> = []; */
  @Input() touchpointListEmission: Array<Touchpoint> = [];
  /*   @Input() touchpointListFruition: Array<Touchpoint> = []; */
  @Input() language: string = "it";
  @Input() dateFormat: string = "dd/MM/yyyy";

  @Output() editClicked: EventEmitter<number> = new EventEmitter<number>();


  private interval: any;

  /*
    certifications = {
      promo: false,
      B2_001: true,
      A1_001: false
    }
    */

  //parametri per processare messageInstanceObject
  /*********************EMISSION*************************/

  //CV
  emissionTreshold;//PTRE
  emissionTrasholdType;//PTRT
  emissionMaxCouponNumber;//PMCN
  ripetibleEmissionTreshold;//PRTR

  //LM TransactionFruitionLimit
  emissionTACM //TACM
  emissionPMCT  //PMCT

  //AC
  emissionAccumulator;//TACM
  emissionAccumulationRule;//JAAR
  emissionControlRule;//JACR

  //CT
  distributionEmissionList; //TDIS;

  //OL
  touchPointEmission: Array<any> = [] //TOCH



  //PT
  basket = {
    exclude: 0,
    include: 0
  };
  productDepartment = {
    exclude: 0,
    include: 0
  };
  productCategory = {
    exclude: 0,
    include: 0
  };
  productItem = {
    exclude: 0,
    include: 0
  };
  //WZ
  wizardEmission;

  /*********************FRUITION*************************/
  /*
    //CV fruition
    fruitionTreshold//PTRE
    fruitionTrasholdType;//PTRT
    fruitionMaxCouponNumber;//PMCN
    ripetibleFruitionTreshold;//PRTR

    //LM fruition
    fruitionPMCT: string;
    fruitionTACM: any;

    //CT fruition
    distributionFruitionList;

    //AC fruition
    fruitionAccumulator;//TACM;
    fruitionAccumulationRule;//JAAR
    fruitionControlRule;//JACR

    //OL
    touchPointFruition: Array<Touchpoint> = [] //TOCH

    //PT
    basketFruition = {
      exclude: 0,
      include: 0
    };
    productDepartmentFruition = {
      exclude: 0,
      include: 0
    };
    productCategoryFruition = {
      exclude: 0,
      include: 0
    };
    productItemFruition = {
      exclude: 0,
      include: 0
    };
      //WZ
      wizardFruition
   */
  /*********************COMMON*************************/

  //BA
  productItemBarcodeAttivazione;//TBCD
  eanBarcodeAttivazione;//PBCD

  //BC
  productItemBarcodeCupon;//TBCD
  eanBarcodeCoupon;//PBCD

  /******************FRONTEND-DATA***********************/

  //date
  startFruitionDate;
  endFruitionDate;

  //date
  startEmissionDate;
  endEmissionDate;


  //cambiamenti
  emissionAccumulatorToMove;
  emissionAccumulatorToControl;

  //bodyInfo
  actionType;
  name;
  discountType;
  generationMethod;
  targetLoyaltyClass;
  description;
  actualGeneratedCoupon;
  id;
  @ViewChildren('wizard') wizardComponent: QueryList<FormFields>;

  //appositi per semplificare html del popup
  barcodeCoupon;
  barcodeAttivazione;
  accumulatoriEmissione;
  /*   accumulatoriFruizione; */
  listaDistribuzioneEmissione;
  /*   listaDistribuzioneFruizione; */
  targetArticoliEmissione;
  /*   targetArticoliFruizione; */
  touchPointEmissione;
  /*  touchPointFruizione; */
  numeroNegoziEmissione;
  /*  numeroNegoziFruizione; */
  sogliaDiEmissione: { type: string, value: number };
  /*  sogliaDiFruizione: { type: string, value: number }; */
  emissioneRipetibile: { type: string, value: number, max: number };
  /*  fruizioneRipetibile: { type: string, value: number, max: number }; */

  variableDates: boolean = false;



  disablingSavingWizardState: boolean = false;
  couponingMethodMap = {
    'D': 'Dinamico',
    'S': 'Statico'
  };
  customerTarget = {
    'LOY': 'Loyalty',
    'ALL': 'Tutti',
    'NoLoy': 'No Loyalty'
  };

  statusDescription: string = "";
  @Output() resetState: EventEmitter<any> = new EventEmitter();
  publicationRejected: boolean = false;
  publicationRejectedMsgError: string = '';
  wizardMessagge: boolean = false;
  displayDeleteDialog: boolean = false;

  summaryAccumulatorToMove: any[] = [];
  summaryAccumulatorToControl: any[] = [];

  constructor(
    public srvCampaign3: Campaign3Service,
    private translate: TranslateService,
    private srvCalTranslate: CalendarTranslateService,
    private srvNotify: MessageService,
    public router: Router

  ) {

  }
  ngOnInit() {

    /*
      NOTA IMPORTANTE: quando sono quì a Validazioni, devo iniziare a considerare il campo "status" della
      message instance, come lo stato attuale. Da quì tutte le operazioni che verranno fatte sullo stato,
      verranno considerate come stato attuale e non "il prossimo stato incompleto" come avveniva per i vari tab
    */

    /***
     *
     * LISTA STATI per validazione:
     *
     * 0 --> completa pronta per la preview
     * G --> Generata in preview
     * R --> In generazione preview
     * E --> Errore generazione preview
     * P --> Pubblicata
     * S --> Pubblicazione in invio
     * Q --> Richiesta pubblicazione
     * X --> Pubblicazione rifiutata
     *
     *  ***/

    this.show.form = true;
    console.log("messageInstanceObject", this.messageInstanceObject);

    this.reloadData();  //carica i dati da visualizzare e setta alcune cose
    this.setStatusDescription();
  }
  setStatusDescription() {

    let currentStatus = this.statusList.find(x => x.code == this.messageInstanceObject.status);
    if (currentStatus) {
      this.statusDescription = currentStatus.description;
    }
  }
  getCertifierValue(yesOrNo: boolean): string {
    if (yesOrNo == true) {
      return this.srvCampaign3.touchpointCertifier.YES;
    }
    else {
      return this.srvCampaign3.touchpointCertifier.NO;
    }
  }
  getCertifiedValue(yesOrNo: boolean): string {
    if (yesOrNo == true) {
      return this.srvCampaign3.touchpointCertified.YES;
    }
    else {
      return this.srvCampaign3.touchpointCertified.NO;
    }
  }
  checkCertificationInfo() {

    var self = this;

    this.srvCampaign3.getAllCertificationTouchpoint(this.messageInstanceObject.id).subscribe(res => {

      if (res) {
        self.certificationTouchpointList = Object.assign({}, res);


        for (let tp of self.touchPointEmission) {
          if (tp.certifier == self.srvCampaign3.touchpointCertifier.YES) {
            self.certificationInfo.needsCertification = true;
            break;
          }
        }

        /*   for(let tp of self.touchPointFruition){
            if(tp.certifier == self.srvCampaign3.touchpointCertifier.YES){
              self.certificationInfo.needsCertification = true;
              break;
            }
          }
        */
        self.certificationInfo.isCertificated = (self.certificationTouchpointList.notCertifiedTouchpoint && self.certificationTouchpointList.notCertifiedTouchpoint.length > 0) ? false : true;

        if (self.messageInstanceObject.status == "G" && self.certificationInfo.isCertificated) {
          self.show.generaDefinitiviRichiediPubblicazioni = true;
          self.disable.generaDefinitiviRichiediPubblicazioni = +this.actualGeneratedCoupon > 0 ? false : true;
        }

        if (self.certificationInfo.needsCertification && !self.certificationInfo.isCertificated) {
          self.disable.generaDefinitiviRichiediPubblicazioni = true;
        }

      }
      self.certificationInfo.loaded = true;
    });
  }
  /*
  checkCertificationInfo_OLD(){
    this.certificationInfo.needsCertification = false;

    for(let tp of this.touchPointEmission){
      tp.certified = this.srvCampaign3.touchpointCertified.NO;
      if(tp.certifier == this.srvCampaign3.touchpointCertifier.YES){
        this.certificationInfo.needsCertification = true;
        break;
      }
    }

    for(let tp of this.touchPointFruition){
      tp.certified = this.srvCampaign3.touchpointCertified.NO;
      if(tp.certifier == this.srvCampaign3.touchpointCertifier.YES){
        this.certificationInfo.needsCertification = true;
        break;
      }
    }

    if(this.certificationInfo.needsCertification==true){
      var self = this;

      this.srvCampaign3.getAllCertificationTouchpoint(this.messageInstanceObject.id).subscribe(res=>{
        if(res){
          self.certificationTouchpointList = Object.assign({},res);

          if(self.certificationTouchpointList.certifiedTouchpoint && self.certificationTouchpointList.certifiedTouchpoint.length>0){
            //se si scatena questa chiamata allora dall'elenco touchpoint già so che c'è almeno un touchpoint certificatore (this.certificationInfo.needsCertification = true)

            for(let tp of this.touchPointEmission){
              if(tp.certifier == self.srvCampaign3.touchpointCertifier.YES){
                let certificationTP = self.certificationTouchpointList.certifiedTouchpoint.find(x=>x.touchpointId == tp.ochannel_id);
                if(certificationTP){
                  tp.certified = certificationTP.status == "1" ? self.srvCampaign3.touchpointCertified.YES : self.srvCampaign3.touchpointCertified.NO;
                }
              }
            }

            for(let tp of this.touchPointFruition){
              if(tp.certifier == self.srvCampaign3.touchpointCertifier.YES){
                let certificationTP = self.certificationTouchpointList.certifiedTouchpoint.find(x=>x.touchpointId == tp.ochannel_id);
                if(certificationTP){
                  tp.certified = certificationTP.status == "1" ? self.srvCampaign3.touchpointCertified.YES : self.srvCampaign3.touchpointCertified.NO;
                }
              }
            }

            //se c'è almeno un certificatore e allo stesso tempo ho uno che non ha certificato, allora non posso pubblicare. Altrimenti posso pubblicare, sia se non ho certificatori, sia se ho tutti certificati.
            self.certificationInfo.isCertificated = (this.touchPointEmission.findIndex(x=>x.certifier == self.srvCampaign3.touchpointCertifier.YES)>-1) && (this.touchPointEmission.findIndex(x=>x.certified == self.srvCampaign3.touchpointCertified.NO)>-1) ? false : true;
          }

        }
        self.certificationInfo.loaded = true;
      });

    }
    else{
      this.certificationInfo.loaded = true;
    }
  }
  */
  enableCheckStatusContinuous(enabled: boolean) {
    if (enabled == true) {
      var self = this;
      this.interval = setInterval(() => {
        if (self.messageInstanceObject.status == "Q" || self.messageInstanceObject.status == "S" || self.messageInstanceObject.status == "R") {
          self.reloadStatusData();
        }
      }, 10000);
    }
    else {
      clearInterval(this.interval);
    }
  }
  reloadInfoStatus() {
    let currentStatus = this.statusList.find(x => x.code == this.messageInstanceObject.status);

    if (currentStatus) {
      this.statusDescription = currentStatus.description;

      if (
        currentStatus.code == this.statusMapping.infoBase.code ||
        currentStatus.code == this.statusMapping.planning.code ||
        currentStatus.code == this.statusMapping.emissionConditions.code ||

        currentStatus.code == this.statusMapping.customerTarget.code ||
        currentStatus.code == this.statusMapping.productsTarget.code ||
        currentStatus.code == this.statusMapping.touchpoints.code ||
        currentStatus.code == this.statusMapping.validations.code
      ) {
        this.loadSchema(this.srvCampaign3.schema_modes.CREATE)
      }
      else if (
        currentStatus.code == this.statusMapping.completaPreview.code ||
        currentStatus.code == this.statusMapping.generataInPreview.code ||
        currentStatus.code == this.statusMapping.generazioneInErrore.code ||
        currentStatus.code == this.statusMapping.pubblicazioneRifiutata.code
      ) {
        this.loadSchema(this.srvCampaign3.schema_modes.EDIT_PREVIEW)
      }
      else if (currentStatus.code == this.statusMapping.pubblicata.code) {
        this.loadSchema(this.srvCampaign3.schema_modes.EDIT_DEFINITIVE)
      }
    }
  }
  processData(localData: MessageInstanceObject) {
    this.mapBodyData(localData);
    this.countStores(localData);
    this.mapInstanceData(localData);


    this.summaryAccumulatorToControl = [];
    this.summaryAccumulatorToMove = [];

    this.frontEndLogic(localData);




    this.setStatusDescription();
    //se presente una regola wz setta i wizard
    if (this.messageInstanceObject && this.messageInstanceObject.messageInstanceRule && this.messageInstanceObject.messageInstanceRule.length > 0) {
      if (this.messageInstanceObject.messageInstanceRule.some(rule => rule.ruleType === "WZ")) {
        this.setWizardValue();
      }
    }
    if (this.touchPointEmission) {
      this.checkWizardList();
    }
  }


  //chiamato per valorizzare i wizard se presenti le regole
  setWizardValue() {
    let rulesEmission_WZ = this.messageInstanceObject.messageInstanceRule.find(x => x.ruleTypeId == this.miRuleTypesList.find(x => x.code == "WZ").id && x.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.EMISSION);


    if (rulesEmission_WZ && rulesEmission_WZ.messageInstanceRuleDetail && rulesEmission_WZ.messageInstanceRuleDetail.length > 0) {
      for (let mird of rulesEmission_WZ.messageInstanceRuleDetail) {
        if (mird.objectTypeId == this.miObjectTypesList.find(x => x.code == "TWIZ").id) {
          let tp_E_ON = this.touchPointEmission.find(x => x.ochannel_id == mird.objectValue);
          if (tp_E_ON && mird.objectValue && mird.objectId) {
            tp_E_ON.wizardModel = (tp_E_ON.wizardList && tp_E_ON.wizardList.length > 0) ? tp_E_ON.wizardList.find(x => x.id == mird.objectId) : null;
            if (mird.objectPriorty) {
              tp_E_ON["priority"] = mird.objectPriorty;
            }
          }
        }
      }
    };





  }
  //navigazione durante l'edit
  onEdit(phaseNumber) {
    if (phaseNumber >= 0) {
      this.editClicked.emit(phaseNumber)
    }
  }
  performValidationValidationTarget(): boolean {
    let error = false;
    this.valid = (error == false) ? true : false;
    return this.valid;
  }



  resetDeploy(id) {

    let nextStatus = '0';
    this.srvCampaign3.resetDeploymentStateToComplete(id, nextStatus).subscribe(
      res => {
        console.log(res);
        this.resetState.emit();
      }
    )
  }
  mapBodyData(localData: any) {
    this.startEmissionDate = localData.startEmissionDate;
    this.endEmissionDate = localData.endEmissionDate;
    this.startFruitionDate = localData.startFruitionDate;
    this.endFruitionDate = localData.endFruitionDate;
    this.actionType = localData.actionType;
    this.name = localData.name;
    this.discountType = localData.discountType;
    this.description = localData.couponAmt / 100;
    this.actualGeneratedCoupon = localData.actualGeneratedCoupon;
    this.id = localData.id;

    //capire se la pubblicazione è stata rifiutata

    if (localData.status == "X") {
      this.publicationRejected = true;
      this.publicationRejectedMsgError = localData.couponDeploy.dpl_message;
    } else {
      this.publicationRejected = false;
      this.publicationRejectedMsgError = '';
    }

  }
  setAllButtonsVisible(isVisible: boolean) {
    this.show.aggiornaAzione = isVisible;
    this.show.generaCouponPreview = isVisible;
    this.show.generaDefinitiviRichiediPubblicazioni = isVisible;
    this.show.annullaPubblicazione = isVisible;
  }
  setAllButtonsDisable(isDisabled: boolean) {
    this.disable.aggiornaAzione = isDisabled;
    this.disable.generaCouponPreview = isDisabled;
    this.disable.generaDefinitiviRichiediPubblicazioni = isDisabled;
    this.disable.annullaPubblicazione = isDisabled;
  }
  isGeneraDefinitivoEnabled(): boolean {
    let res = true;
    if (this.certificationInfo.needsCertification && !this.certificationInfo.isCertificated)
      res = false;
    return res;
  }
  checkForButtons() {
    this.setAllButtonsVisible(false);
    this.setAllButtonsDisable(false);
    this.checkIfAWizardIsSaved();
    this.checkIfGenerated()

    var self = this;
    setTimeout(function () {

      //stato 0 --> completa, in preview
      //stato E --> quando si chiede la generazione in preview, se ci sono errori va in stato E
      if (self.messageInstanceObject.status == "0" || self.messageInstanceObject.status == "E") {
        self.show.generaCouponPreview = true;
        self.show.generaDefinitiviRichiediPubblicazioni = true;
        self.show.annullaPubblicazione = true;
        self.disable.generaDefinitiviRichiediPubblicazioni = true;
        self.disable.annullaPubblicazione = true;
      }

      //stato G --> promo generata in preview
      else if (self.messageInstanceObject.status == "G") {
        self.show.generaDefinitiviRichiediPubblicazioni = true;
        self.show.annullaPubblicazione = true;
        self.disable.annullaPubblicazione = true;
        self.disable.generaDefinitiviRichiediPubblicazioni = (+self.actualGeneratedCoupon) > 0 && self.isGeneraDefinitivoEnabled() == true ? false : true;
      }
      //stato Q --> richiesta pubblicazione
      //stato S --> pubblicazione invio
      //stato R --> in generazione coupon di preview
      else if (self.messageInstanceObject.status == "Q" || self.messageInstanceObject.status == "S" || self.messageInstanceObject.status == "R") {
        self.show.aggiornaAzione = true;
        self.show.pubblicaNuovamente = false;
        self.wizardMessagge = false;
      }
      //stato P --> promo pubblicata
      else if (self.messageInstanceObject.status == "P" && self.messageInstanceObject.flgDpl == '0') {
        self.show.annullaPubblicazione = true;
        //Attenzione provvisorio
        self.show.pubblicaNuovamente = true;
      }
      else if (self.messageInstanceObject.status == "P" && self.messageInstanceObject.flgDpl == '1') {
        self.show.annullaPubblicazione = true;
        //Attenzione provvisorio
        self.show.pubblicaNuovamente = true;
        self.disablingSavingWizardState = false;
        self.wizardMessagge = false;
        //proviamo a valutare la presenza dei wizard se ne ho almeno uno viene applicata la logica
        const hasWizard = self.messageInstanceObject.messageInstanceRule.some(
          element => element.ruleType === "WZ"
        );

        if (hasWizard) {
          console.log("Trovato almeno un wizard");
          self.wizardMessagge = false;
          self.disablingSavingWizardState = true;
          self.show.pubblicaNuovamente = true;
        } else {
          console.log("Nessun wizard salvato");
          self.wizardMessagge = true;
          self.disablingSavingWizardState = false;
          self.show.pubblicaNuovamente = false;
        }

      }

      //stato X --> pubblicazione rifiutata
      else if (self.messageInstanceObject.status == "X") {
        self.show.pubblicaNuovamente = false;

      }
      //stato U --> pubblicazione annullata
      else if (self.messageInstanceObject.status == "U") {

      }

    }, 100);

  }
  countStores(data: any) {
    if (data.storeMessageOChannel) {
      let storeMessageList = data.storeMessageOChannel;
      let emission = [];
      let fruition = [];
      for (let record of storeMessageList) {
        if (record.storeType == 'E') {
          emission.push(record);
        }
        if (record.storeType == 'F') {
          fruition.push(record);
        }
      }
      this.numeroNegoziEmissione = emission.length;
      /*  this.numeroNegoziFruizione = fruition.length;
  */
    } else {
      this.numeroNegoziEmissione = 0;
      /*   this.numeroNegoziFruizione = 0; */
    }
  }

  mapInstanceData(data: any) {

    this.basket.include = 0;
    this.productDepartment.include = 0;
    this.productCategory.include = 0;
    this.productItem.include = 0;
    this.basket.exclude = 0;
    this.productDepartment.exclude = 0;
    this.productCategory.exclude = 0;
    this.productItem.exclude = 0;

    /*   this.basketFruition.include = 0;
      this.productDepartmentFruition.include = 0;
      this.productCategoryFruition.include = 0;
      this.productItemFruition.include = 0;
      this.basketFruition.exclude = 0;
      this.productDepartmentFruition.exclude = 0;
      this.productCategoryFruition.exclude = 0;
      this.productItemFruition.exclude = 0; */

    let messageInstanceRule = data.messageInstanceRule;

    //CV list
    let cvInstanceRuleDetail;
    let cvInstanceRuleDetailFruition;

    //LM List
    let lmInstanceRuleList;

    //AC List
    let acInstanceRuleDetail;

    //BA List
    let baInstanceRuleDetail;

    //BC List
    let bcInstanceRuleDetail;

    //CT List
    let ctInstanceRuleDetail;
    let ctInstanceRuleDetailFruition;

    //OL List
    let olEmissionInstanceRuleDetail;
    let olFruitionInstanceRuleDetail;

    //PT List
    let ptInstanceRuleDetail;
    let ptInstanceRuleDetailFruition;

    //WZ List
    let wizardInstanceRuleDetail;
    let wizardInstanceRuleDetailFruition;


    if (messageInstanceRule) {
      for (let data of messageInstanceRule) {

        /*------------------------------CV--------------------------------*/

        //lista coupon con cv
        if (data.ruleType == "CV" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.EMISSION) {
          cvInstanceRuleDetail = data.messageInstanceRuleDetail;
        }
        //lista coupon con cv fruizione
        if (data.ruleType == "CV" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.FRUITION) {
          cvInstanceRuleDetailFruition = data.messageInstanceRuleDetail;
        }

        /*------------------------------LM--------------------------------*/

        //lista coupon con cv
        if (data.ruleType == "CV" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.EMISSION) {
          lmInstanceRuleList = data.messageInstanceRuleDetail;
        }
        //lista coupon con cv fruizione
        if (data.ruleType == "CV" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.FRUITION) {
          lmInstanceRuleList = data.messageInstanceRuleDetail;
        }

        /*------------------------------AC--------------------------------*/

        //lista accumulatori
        if (data.ruleType == "AC" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.EMISSION) {
          acInstanceRuleDetail = data.messageInstanceRuleDetail;
        }



        /*------------------------------CT--------------------------------*/
        //lista customer target emission
        if (data.ruleType == "CT" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.EMISSION) {
          ctInstanceRuleDetail = data.messageInstanceRuleDetail;
        }

        //lista customer target fruition
        if (data.ruleType == "CT" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.FRUITION) {
          ctInstanceRuleDetailFruition = data.messageInstanceRuleDetail;
        }

        /*------------------------------OL--------------------------------*/


        if (data.ruleType == "OL" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.EMISSION) {
          olEmissionInstanceRuleDetail = data.messageInstanceRuleDetail;
        }

        //lista touchPointFruition
        if (data.ruleType == "OL" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.FRUITION) {
          olFruitionInstanceRuleDetail = data.messageInstanceRuleDetail;
        }

        /*---------------------------BA & BC------------------------------*/

        //lista barcode attivatore
        if (data.ruleType == "BA" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.EMISSION) {
          baInstanceRuleDetail = data.messageInstanceRuleDetail;
        }
        //lista barcode coupon
        if (data.ruleType == "BC" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.EMISSION) {
          bcInstanceRuleDetail = data.messageInstanceRuleDetail;

        }

        /*------------------------------PT--------------------------------*/

        // lista per targetArticoliEmissione
        if (data.ruleType == "PT" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.EMISSION) {
          ptInstanceRuleDetail = data.messageInstanceRuleDetail;
        }
        // lista per targetArticoliFruizione
        if (data.ruleType == "PT" && data.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.FRUITION) {
          ptInstanceRuleDetailFruition = data.messageInstanceRuleDetail;
        }

      }

    }

    /***********************CV**************************/
    //dettagli del CV emissione
    if (cvInstanceRuleDetail) {

      for (let record of cvInstanceRuleDetail) {

        if (record && record.objectTypeCode == "PTRE") {
          this.emissionTreshold = record.objectValue / 100;
        }
        if (record && record.objectTypeCode == "PTRT") {
          this.emissionTrasholdType = record.objectValue;
        }
        /*
        if (record && record.objectTypeCode == "PMCN") {
          this.emissionMaxCouponNumber = record.objectValue;
        }
        */
        if (record && record.objectTypeCode == "PRTR") {
          this.ripetibleEmissionTreshold = record.objectValue / 100;
        }
        //
      }
    }
    /*   //dettagli del CV fruizione
      if (cvInstanceRuleDetailFruition) {
        for (let record of cvInstanceRuleDetailFruition) {
          //emissionTreshold fruizione
          if (record && record.objectTypeCode == "PTRE") {
            this.fruitionTreshold = record.objectValue/100;
          }
          if (record && record.objectTypeCode == "PTRT") {
            this.fruitionTrasholdType = record.objectValue;
          }
          if (record && record.objectTypeCode == "PMCN") {
            this.fruitionMaxCouponNumber = record.objectValue;
          }
          if (record && record.objectTypeCode == "PRTR") {
            this.ripetibleFruitionTreshold = record.objectValue;
          }

        }
      } */
    /***********************LM**************************/


    if (lmInstanceRuleList) {
      for (let record of lmInstanceRuleList) {
        if (record && record.objectTypeCode == "TACM") {

          this.emissionTACM = record.description;
        }
        if (record && record.objectTypeCode == "PMCT") {
          //TODO attenzione campo complesso
          this.emissionPMCT = 'campo complesso TODO';
        }
      }
    }

    /*   if (lmInstanceRuleListFruition) {
        for (let record of lmInstanceRuleListFruition) {
          if (record && record.objectTypeCode == "TACM") {

            this.fruitionTACM = record.description;
          }
          if (record && record.objectTypeCode == "PMCT") {
            //TODO attenzione campo complesso
            this.fruitionPMCT = 'campo complesso TODO';
          }
        }
      } */

    /***********************AC**************************/

    if (acInstanceRuleDetail) {
      for (let record of acInstanceRuleDetail) {

        if (record && record.objectTypeCode == "JAAR") {

          this.emissionAccumulatorToMove = record.objectJson;
        }
        if (record && record.objectTypeCode == "JACR") {

          this.emissionAccumulatorToControl = record.objectJson;
        }

      }
    }





    /***********************BA**************************/

    //dettagli di barcodeAttivazione
    if (baInstanceRuleDetail) {
      for (let record of baInstanceRuleDetail) {
        if (record && record.objectTypeCode == "TBCD" || record.objectTypeCode == "PBCD") {
          if (record && record.objectTypeCode == "TBCD") {

            this.productItemBarcodeAttivazione = record.objectValue;
          }
          if (record && record.objectTypeCode == "PBCD") {

            this.eanBarcodeAttivazione = record.objectValue;
          }
        }
      }
    }
    /***********************BC**************************/
    //dettagli di productItemBarcodeCupon

    if (bcInstanceRuleDetail) {
      for (let record of bcInstanceRuleDetail) {
        if (record && record.objectTypeCode == "TBCD") {

          this.productItemBarcodeCupon = record.objectValue;
        }
        if (record && record.objectTypeCode == "PBCD") {

          this.eanBarcodeCoupon = record.objectValue;
        }
      }
    }

    /***********************CT**************************/
    //dettagli di distributionEmissionList
    if (ctInstanceRuleDetail) {
      for (let record of ctInstanceRuleDetail) {
        if (record && record.objectTypeCode == "TDIS") {
          let dist = this.distributionListEmission.find(x => x.distributionListId == record.objectId);
          this.distributionEmissionList = dist ? dist.distributionListName : "";
        }
      }
    }
    //dettagli di distributionEmissionListFruition
    /*   if (ctInstanceRuleDetailFruition) {
        for (let record of ctInstanceRuleDetailFruition) {
          if (record && record.objectTypeCode == "TDIS") {
            let dist = this.distributionListFruition.find(x=>x.distributionListId == record.objectId);
            this.distributionFruitionList = dist ? dist.distributionListName : "";
          }
        }
      } */


    /***********************OL**************************/
    //dettagli di touchpointEmission
    if (olEmissionInstanceRuleDetail) {
      this.touchPointEmission = [];
      for (let record of olEmissionInstanceRuleDetail) {
        if (record && record.objectTypeCode == "TOCH") {
          let tp = this.touchpointListEmission.find(x => x.ochannel_id == record.objectId);
          if (tp) {
            this.touchPointEmission.push(tp);
          }
        }

      }
    }
    /*     //dettagli di touchPointFruition
        if (olFruitionInstanceRuleDetail) {
          this.touchPointFruition = [];
          for (let record of olFruitionInstanceRuleDetail) {
            if (record && record.objectTypeCode == "TOCH") {
              let tp = this.touchpointListFruition.find(x=>x.ochannel_id == record.objectId);
              if(tp){
                this.touchPointFruition.push(tp);
              }
            }

          }
        } */
    /***********************WZ**************************/
    //TODO per ora prelevo e displayo l'objectTypeId vedere se effettuare ulteriori elaborazioni sul dato (riportare anche su parte di ferderico della validazione)

    if (wizardInstanceRuleDetail) {
      for (let record of wizardInstanceRuleDetail) {
        if (record && record.objectTypeCode == "TWIZ") {
          this.wizardEmission = record.objectTypeId;
        }
      }
    }
    /*  if (wizardInstanceRuleDetailFruition) {
       for (let record of wizardInstanceRuleDetailFruition) {
         if (record && record.objectTypeCode == "TWIZ") {
           this.wizardFruition = record.objectTypeId;
         }
       }
     } */

    /***********************PT**************************/

    //Chiedere come trattare INCLUDE e EXCLUDE

    if (ptInstanceRuleDetail) {

      for (let record of ptInstanceRuleDetail) {

        if (record && record.objectTypeCode == "TBSK") {
          if (record.objectInclude == this.srvCampaign3.ruleIncludeExclude.INCLUDE) {
            this.basket.include++;
          }
          else if (record.objectInclude == this.srvCampaign3.ruleIncludeExclude.EXCLUDE) {
            this.basket.exclude++;
          }
        }
        if (record && record.objectTypeCode == "TDEP") {
          if (record.objectInclude == this.srvCampaign3.ruleIncludeExclude.INCLUDE) {
            this.productDepartment.include++;
          }
          else if (record.objectInclude == this.srvCampaign3.ruleIncludeExclude.EXCLUDE) {
            this.productDepartment.exclude++;
          }
        }
        if (record && record.objectTypeCode == "TCAT") {
          if (record.objectInclude == this.srvCampaign3.ruleIncludeExclude.INCLUDE) {
            this.productCategory.include++;
          }
          else if (record.objectInclude == this.srvCampaign3.ruleIncludeExclude.EXCLUDE) {
            this.productCategory.exclude++;
          }
        }
        if (record && record.objectTypeCode == "TPRD") {
          if (record.objectInclude == this.srvCampaign3.ruleIncludeExclude.INCLUDE) {
            this.productItem.include++;
          }
          else if (record.objectInclude == this.srvCampaign3.ruleIncludeExclude.EXCLUDE) {
            this.productItem.exclude++;
          }
        }
      }
    }

    /*  if (ptInstanceRuleDetailFruition) {

       for (let record of ptInstanceRuleDetailFruition) {

         if (record && record.objectTypeCode == "TBSK") {
           if(record.objectInclude == this.srvCampaign3.ruleIncludeExclude.INCLUDE){
             this.basketFruition.include++;
           }
           else if(record.objectInclude == this.srvCampaign3.ruleIncludeExclude.EXCLUDE){
             this.basketFruition.exclude++;
           }
         }
         if (record && record.objectTypeCode == "TDEP") {
           if(record.objectInclude == this.srvCampaign3.ruleIncludeExclude.INCLUDE){
             this.productDepartmentFruition.include++;
           }
           else if(record.objectInclude == this.srvCampaign3.ruleIncludeExclude.EXCLUDE){
             this.productDepartmentFruition.exclude++;
           }
         }
         if (record && record.objectTypeCode == "TCAT") {
           if(record.objectInclude == this.srvCampaign3.ruleIncludeExclude.INCLUDE){
             this.productCategoryFruition.include++;
           }
           else if(record.objectInclude == this.srvCampaign3.ruleIncludeExclude.EXCLUDE){
             this.productCategoryFruition.exclude++;
           }
         }
         if (record && record.objectTypeCode == "TPRD") {
           if(record.objectInclude == this.srvCampaign3.ruleIncludeExclude.INCLUDE){
             this.productItemFruition.include++;
           }
           else if(record.objectInclude == this.srvCampaign3.ruleIncludeExclude.EXCLUDE){
             this.productItemFruition.exclude++;
           }
         }

       }
     } */
  }

  frontEndLogic(localData: any) {
    if (localData.flgRolling == "1") {
      this.variableDates = true;
    }

    this.generationMethod = this.couponingMethodMap[localData.flgCouponingMethod] || '';
    this.targetLoyaltyClass = this.customerTarget[localData.targetLoyaltyClass] || '';

    //Barcode Attivazione
    if (this.productItemBarcodeAttivazione) {
      this.barcodeAttivazione = this.productItemBarcodeAttivazione;
    } else if (this.eanBarcodeAttivazione) {
      this.barcodeAttivazione = this.eanBarcodeAttivazione;
    }
    if (!this.barcodeAttivazione) {
      this.barcodeAttivazione = 'No';
    }
    //Barcode Coupon
    if (this.productItemBarcodeCupon) {
      this.barcodeCoupon = this.productItemBarcodeCupon;
    } else if (this.eanBarcodeCoupon) {
      this.barcodeCoupon = this.eanBarcodeCoupon;
    }
    if (!this.barcodeCoupon) {
      this.barcodeCoupon = 'No';
    }

    //Accumulatori in emissione
    if (this.emissionAccumulator) {
      this.accumulatoriEmissione = 'Si' //+ this.emissionAccumulator;
    } else {
      this.accumulatoriEmissione = 'No';
    }

    /*   //Accumulatori in fruizione
      if (this.fruitionAccumulator) {
        this.accumulatoriFruizione = 'Si' // + this.fruitionAccumulator;
      } else {
        this.accumulatoriFruizione = 'No';
      }
   */
    //listaDistribuzioneEmissione
    if (this.distributionEmissionList) {
      this.listaDistribuzioneEmissione = 'Si' + ' (' + this.distributionEmissionList + ')';
    }
    else {
      this.listaDistribuzioneEmissione = 'nessuna';
    }

    /*   //listaDistribuzioneFruizione
      if (this.distributionFruitionList) {
        this.listaDistribuzioneFruizione = 'Si' + ' (' + this.distributionFruitionList + ')';
      }
      else {
        this.listaDistribuzioneFruizione = 'nessuna';
      } */

    if ((this.basket.include + this.basket.exclude + this.productDepartment.include + this.productDepartment.exclude + this.productCategory.include + this.productCategory.exclude + this.productItem.include + this.productItem.exclude) > 0) {

      this.targetArticoliEmissione = "(";

      if ((this.basket.include + this.basket.exclude) > 0) {
        this.targetArticoliEmissione += "paniere ";
        this.targetArticoliEmissione += this.basket.include > 0 ? this.basket.include + " (I), " : "";
        this.targetArticoliEmissione += this.basket.exclude > 0 ? this.basket.exclude + " (E), " : "";
      }
      if ((this.productDepartment.include + this.productDepartment.exclude) > 0) {
        this.targetArticoliEmissione += "reparto ";
        this.targetArticoliEmissione += this.productDepartment.include > 0 ? this.productDepartment.include + " (I), " : "";
        this.targetArticoliEmissione += this.productDepartment.exclude > 0 ? this.productDepartment.exclude + " (E), " : "";
      }
      if ((this.productCategory.include + this.productCategory.exclude) > 0) {
        this.targetArticoliEmissione += "categorie ";
        this.targetArticoliEmissione += this.productCategory.include > 0 ? this.productCategory.include + " (I), " : "";
        this.targetArticoliEmissione += this.productCategory.exclude > 0 ? this.productCategory.exclude + " (E), " : "";
      }
      if ((this.productItem.include + this.productItem.exclude) > 0) {
        this.targetArticoliEmissione += "articoli ";
        this.targetArticoliEmissione += this.productItem.include > 0 ? this.productItem.include + " (I), " : "";
        this.targetArticoliEmissione += this.productItem.exclude > 0 ? this.productItem.exclude + " (E), " : "";
      }
      this.targetArticoliEmissione = this.targetArticoliEmissione.slice(0, -2);
      this.targetArticoliEmissione += ")";
    } else {
      this.targetArticoliEmissione = 'no';
    }

    /* if ((this.basketFruition.include + this.basketFruition.exclude + this.productDepartmentFruition.include + this.productDepartmentFruition.exclude + this.productCategoryFruition.include + this.productCategoryFruition.exclude + this.productItemFruition.include + this.productItemFruition.exclude) > 0 ) {
      this.targetArticoliFruizione = "(";
      if((this.basketFruition.include + this.basketFruition.exclude)>0){
        this.targetArticoliFruizione += "paniere ";
        this.targetArticoliFruizione += this.basketFruition.include > 0 ? this.basketFruition.include + " (I), " : "";
        this.targetArticoliFruizione += this.basketFruition.exclude > 0 ? this.basketFruition.exclude + " (E), " : "";
      }
      if((this.productDepartmentFruition.include + this.productDepartmentFruition.exclude)>0){
        this.targetArticoliFruizione += "reparto ";
        this.targetArticoliFruizione += this.productDepartmentFruition.include > 0 ? this.productDepartmentFruition.include + " (I), " : "";
        this.targetArticoliFruizione += this.productDepartmentFruition.exclude > 0 ? this.productDepartmentFruition.exclude + " (E), " : "";
      }
      if((this.productCategoryFruition.include + this.productCategoryFruition.exclude)>0){
        this.targetArticoliFruizione += "categorie ";
        this.targetArticoliFruizione += this.productCategoryFruition.include > 0 ? this.productCategoryFruition.include + " (I), " : "";
        this.targetArticoliFruizione += this.productCategoryFruition.exclude > 0 ? this.productCategoryFruition.exclude + " (E), " : "";
      }
      if((this.productItemFruition.include + this.productItemFruition.exclude)>0){
        this.targetArticoliFruizione += "articoli ";
        this.targetArticoliFruizione += this.productItemFruition.include > 0 ? this.productItemFruition.include + " (I), " : "";
        this.targetArticoliFruizione += this.productItemFruition.exclude > 0 ? this.productItemFruition.exclude + " (E), " : "";
      }
      this.targetArticoliFruizione = this.targetArticoliFruizione.slice(0,-2);
      this.targetArticoliFruizione += ")";
    } else {
      this.targetArticoliFruizione = 'no';
    } */

    //Touchpoint Emissione
    if (this.touchPointEmission && this.touchPointEmission.length > 0) {
      this.touchPointEmissione = "";
      for (let tp of this.touchPointEmission) {
        this.touchPointEmissione += tp.description + ", ";
      }
      this.touchPointEmissione = this.touchPointEmissione.slice(0, -2);
    } else {
      this.touchPointEmissione = 'nessuno';
    }
    /* //Touchpoint Fruizione
    if (this.touchPointFruition && this.touchPointFruition.length>0) {
      this.touchPointFruizione = "";
      for(let tp of this.touchPointFruition){
        this.touchPointFruizione += tp.description + ", ";
      }
      this.touchPointFruizione = this.touchPointFruizione.slice(0,-2);
    } else {
      this.touchPointFruizione = 'nessuno';
    }
 */
    //sogliaDiEmissione
    if (this.emissionTrasholdType && this.emissionTrasholdType == "EV") {
      this.sogliaDiEmissione.type = 'Valore';
      this.sogliaDiEmissione.value = this.emissionTreshold;
    }
    //sogliaDiEmissione
    if (this.emissionTrasholdType && this.emissionTrasholdType == "QT") {
      this.sogliaDiEmissione.type = 'Quantità';
      this.sogliaDiEmissione.value = this.emissionTreshold;
    }
    if (!this.emissionTrasholdType) {
      this.sogliaDiEmissione.type = 'No';
    }

    /*   //Soglia di fruizione, TODO attenzione che nella validazione mi ritorna un caso con fruitionTrasholdType=V
      if (this.fruitionTrasholdType && this.fruitionTrasholdType == "EV") {
        this.sogliaDiFruizione.type = 'Valore';
        this.sogliaDiFruizione.value = this.fruitionTreshold;
      }
      if (this.fruitionTrasholdType && this.fruitionTrasholdType == "QT") {
        this.sogliaDiFruizione.type = 'Quantità';
        this.sogliaDiFruizione.value = this.fruitionTreshold;
      }
      if (!this.fruitionTrasholdType) {
        this.sogliaDiFruizione.type = 'No';
      } */
    // console.log(this.emissionMaxCouponNumber)

    //Emissione Ripetibile
    /*
    if (this.ripetibleEmissionTreshold) {

      this.emissioneRipetibile.type = "si";
      const intValue = parseInt(this.emissionMaxCouponNumber);
      if (!isNaN(intValue)) {
        this.emissioneRipetibile.value = intValue / 100;
        this.emissioneRipetibile.max = intValue;
      } else {
        console.error("record.objectValue non è un numero valido");
      }
    } else {
      this.emissioneRipetibile.type = "No";
    }
*/
    /*   //Fruizione Ripetibile
      if (this.ripetibleFruitionTreshold) {
        this.fruizioneRipetibile.type = "si";
        const intValue = parseInt(this.fruitionMaxCouponNumber);
        if (!isNaN(intValue)) {
          this.fruizioneRipetibile.value = intValue / 100;
          this.fruizioneRipetibile.max = intValue;
        } else {
          console.error("record.objectValue non è un numero valido");
        }
      } else {
        this.fruizioneRipetibile.type = "No";
      }
   */

    //Accumulatori EMISSIONE
    // --- Controllo (JACR) ---
    if (this.emissionAccumulatorToControl && Array.isArray(this.emissionAccumulatorToControl.check)) {
      const checkList = this.emissionAccumulatorToControl.check;

      for (let check of checkList) {
        const matchingAccumulator = this.accumulatorListEmission.find(acc => acc.id == check.acm_id);

        if (matchingAccumulator) {
          console.log('Trovato (controllo):', matchingAccumulator);
          this.summaryAccumulatorToControl.push(matchingAccumulator);
        } else {
          console.warn('Accumulatore non trovato per ID (controllo):', check.acm_id);
        }
      }
    }

    // --- Movimentazione (JAAR) ---
    if (this.emissionAccumulatorToMove && Array.isArray(this.emissionAccumulatorToMove.move)) {
      const moveList = this.emissionAccumulatorToMove.move;

      for (let move of moveList) {
        const matchingAccumulator = this.accumulatorListEmission.find(acc => acc.id == move.acm_id);

        if (matchingAccumulator) {
          console.log('Trovato (movimento):', matchingAccumulator);
          this.summaryAccumulatorToMove.push(matchingAccumulator);
        } else {
          console.warn('Accumulatore non trovato per ID (movimento):', move.acm_id);
        }
      }
    }

  }
  reloadData() {
    this.show.form = false;

    this.sogliaDiEmissione = { type: '', value: 0 };
    /*  this.sogliaDiFruizione = { type: '', value: 0 }; */
    this.emissioneRipetibile = { type: '', value: 0, max: 0 };
    /*  this.fruizioneRipetibile = { type: '', value: 0, max: 0 }; */

    var self = this;
    setTimeout(function () {
      if (self.messageInstanceObject) {
        self.processData(self.messageInstanceObject);
        self.checkForButtons();

        if (self.messageInstanceObject.id > 0 && !self.certificationInfo.loaded) {
          self.checkCertificationInfo();
        }
      }
      self.show.form = true;
    }, 100);

  }
  loadSchema(mode: string) {
    //carica il form schema a seconda della scelta della combo tipo coupon
    var self = this;
    //TODO modifica in riunione
    self.srvCampaign3.getJsonFormSchemaMessage(self.actionTypeCode, mode, self.messageInstanceObject.messageId.toString()).subscribe(resSchema => {
      if (resSchema && resSchema.length == 1) {
        let newSchema = self.srvCampaign3.getPreparedFormSchemas(resSchema[0]);
        setTimeout(function () {
          newSchema.mode = mode;
          self.formSchemaChanged.emit(newSchema);
        }, 100)

      }
      else {
        //caso non viene restituito schema, devi fermarti (da gestire)!
        self.formSchemaChanged.emit(null);
        self.srvNotify.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('campaign.no_template_schema')
        });
      }

    });
  }
  //TODO in questo punto chiedere ad antonio co
  onClickGeneraCouponPreview() {

    //this.srvNotify.add({severity: 'info', summary: 'Info', detail: 'Funzione temporaneamente non abilitata! Work in progress...'});
    var self = this;
    this.srvCampaign3.preview(this.campaignInfo.id, this.messageInstanceObject.id, false).subscribe(res => {
      if (res) {
        self.srvNotify.add({
          severity: 'success',
          summary: this.translate.instant('common.success'), // Usa la traduzione per "Success"
          detail: this.translate.instant('campaign.coupon_preview_generation_successful')
        });
      } else {
        self.srvNotify.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('campaign.error_coupon_preview_generation')
        });
      }

      self.reloadStatusData();
    });

  }
  onClickGeneraCouponDefinitivi() {
    //this.srvNotify.add({severity: 'info', summary: 'Info', detail: 'Funzione temporaneamente non abilitata! Work in progress...'});

    if (this.messageInstanceObject.status == "G") {

      let publishable = this.certificationInfo.needsCertification ? (this.certificationInfo.isCertificated == true ? true : false) : false;

      var self = this;
      this.srvCampaign3.publish(this.campaignInfo.id, this.messageInstanceObject.id, publishable).subscribe(res => {
        if (res) {
          self.srvNotify.add({
            severity: 'success',
            summary: this.translate.instant('common.success'), // Usa la traduzione per "Success"
            detail: this.translate.instant('campaign.final_coupon_generation_successful')
          });
        } else {
          self.srvNotify.add({
            severity: 'error',
            summary: this.translate.instant('common.error'),
            detail: this.translate.instant('campaign.error_final_coupon_generation')
          });
        }

        self.reloadStatusData();
      });

    }
    else {
      self.srvNotify.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('campaign.no_conditions_to_publish_promo')
      });
    }
  }
  reloadStatusData() {
    var self = this;
    self.srvCampaign3.getMessageInstanceComplete(self.messageInstanceObject.id).subscribe(res => {
      if (res && res.messageInstance.length == 1) {
        let mi = res.messageInstance[0];
        self.messageInstanceObject = mi;
        self.messageInstanceObjectChange.emit(mi);
        self.checkForButtons();
        self.reloadInfoStatus();
      }
    })
  }
  onClickAggiornaAzione() {
    //this.srvNotify.add({severity: 'info', summary: 'Info', detail: 'Funzione temporaneamente non abilitata! Work in progress...'});
    if (this.messageInstanceObject.status == "Q" || this.messageInstanceObject.status == "S" || this.messageInstanceObject.status == "R") {
      this.reloadStatusData();
    }
  }
  onClickAnnullaPubblicazione() {
    this.displayDeleteDialog = true;
  }

  closePopupDelete() {
    this.displayDeleteDialog = false;
  }


  onAnnullaPubblicazione() {
    //this.srvNotify.add({severity: 'info', summary: 'Info', detail: 'Funzione temporaneamente non abilitata! Work in progress...'});
    var self = this;
    this.srvCampaign3.undoPublish(this.campaignInfo.id, this.messageInstanceObject.id, false).subscribe(res => {
      if (res) {
        self.srvNotify.add({
          severity: 'success',
          summary: this.translate.instant('common.success'), // Usa la traduzione per "Success"
          detail: this.translate.instant('campaign.publication_cancellation_successful')
        });
      } else {
        self.srvNotify.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('campaign.error_during_publication_cancellation')
        });
      }
      // TODO :guardare come allineare a campagna
      // self.reloadData();
      this.displayDeleteDialog = false;
      self.unpublishCompleted.emit();
    })
  }
  @Output() unpublishCompleted = new EventEmitter<void>();
  onClickGeneratedCoupon() {

    if (+this.actualGeneratedCoupon > 0) {
      this.show.modalCoupon = true;
    }
  }
  ngOnDestroy() {
    // Pulizia dell'intervallo quando il componente viene distrutto
    this.enableCheckStatusContinuous(false);
  }
  @Output() saveWizard: EventEmitter<any> = new EventEmitter();
  onSaveWizard() {
    let allValid = true;
    if (this.wizardComponent && this.wizardComponent.length > 0) {
      this.wizardComponent.forEach((component) => {
        if (component.fieldModel == null) {
          allValid = false;
        }
      });
    }
    if (allValid) {
      this.saveWizard.emit();
    } else {
      this.srvNotify.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('campaign.select_all_wizard_warning')
      });
    }
  }
  @Input() miRuleTypesList: Array<MessageInstanceRuleTypes> = [];
  @Input() miObjectTypesList: Array<MessageInstanceObjectTypes> = [];
  rules_OL_emission: Array<MessageInstanceRule> = [];
  rules_WZ_emission: Array<MessageInstanceRule> = [];



  createRules_Wizard() {
    this.rules_WZ_emission = [];


    // Regola Wizard per l'emissione
    let ruleWZ_emission = new MessageInstanceRule();
    ruleWZ_emission.messageInstanceId = this.messageInstanceObject.id;
    ruleWZ_emission.ruleTypeId = this.miRuleTypesList.find(x => x.code == "WZ").id;
    ruleWZ_emission.ruleType = "WZ";
    ruleWZ_emission.messageInstanceRuleDetail = new Array<MessageInstanceRuleDetail>();
    ruleWZ_emission.ruleScope = this.srvCampaign3.ruleScopesEmissionFruition.EMISSION;

    // Touchpoint certifier emissione
    for (let tp of this.touchPointEmission) {
      if (tp.active == true && tp.wizardModel && tp.wizardModel.id > 0) {
        let mird = new MessageInstanceRuleDetail();
        mird.objectTypeCode = "TWIZ";
        mird.objectTypeId = this.miObjectTypesList.find(x => x.code == "TWIZ").id;
        mird.objectId = tp.wizardModel.id;
        mird.objectValue = tp.ochannel_id;
        ruleWZ_emission.messageInstanceRuleDetail.push(mird);
      }
    }

    if (ruleWZ_emission.messageInstanceRuleDetail.length > 0) {
      this.rules_WZ_emission.push(ruleWZ_emission);
    }


    /*  // Regola Wizard per la fruizione
     let ruleWZ_fruition = new MessageInstanceRule();
     ruleWZ_fruition.messageInstanceId = this.messageInstanceObject.id;
     ruleWZ_fruition.ruleTypeId = this.miRuleTypesList.find(x => x.code == "WZ").id;
     ruleWZ_fruition.ruleType = "WZ";
     ruleWZ_fruition.messageInstanceRuleDetail = new Array<MessageInstanceRuleDetail>();
     ruleWZ_fruition.ruleScope = this.srvCampaign3.ruleScopesEmissionFruition.FRUITION;


     // Touchpoint certifier fruizione
     for (let tp of this.touchPointFruition) {
       if (tp.active == true && tp.wizardModel && tp.wizardModel.id > 0) {
         let mird = new MessageInstanceRuleDetail();
         mird.objectTypeCode = "TWIZ";
         mird.objectTypeId = this.miObjectTypesList.find(x => x.code == "TWIZ").id;
         mird.objectId = tp.wizardModel.id;
         mird.objectValue = tp.ochannel_id;
         ruleWZ_fruition.messageInstanceRuleDetail.push(mird);
       }
     }

     if (ruleWZ_fruition.messageInstanceRuleDetail.length > 0) {
       this.rules_WZ_fruition.push(ruleWZ_fruition);
     } */
  }
  isWizardEmissionDisabled: boolean = false;
  checkWizardList() {

    for (let tp of this.touchPointEmission) {

      if (tp.wizardList && tp.certifier == this.srvCampaign3.touchpointCertifier.YES && tp.wizardList.length == 1) {
        tp.wizardModel = tp.wizardList[0];
        if (tp.wizardList.length == 1) {
          this.isWizardEmissionDisabled = true;
        }
      }
    }


  }
  checkIfGenerated() {
    const statusesToDisable = ['G', 'Q', 'P', 'S', 'X', 'U'];

    if (this.messageInstanceObject && statusesToDisable.indexOf(this.messageInstanceObject.status) !== -1) {
      this.disablingSavingWizardState = true;
    }
  }
  noSavingNeeded: boolean = false;


  checkIfAWizardIsSaved_UnicommOK() {

    this.disable.generaCouponPreview = true;
    this.disablingSavingWizardState = false;
    /*  this.isWizardEmissionDisabled = false;
     this.isWizardFruitionDisabled = false;  */

    if (this.messageInstanceObject.messageInstanceRule) {
      this.messageInstanceObject.messageInstanceRule.forEach(el => {

        if (el.ruleType == "WZ") {
          this.disable.generaCouponPreview = false;
          this.disablingSavingWizardState = true;

        }
      });
    }

  }
  //TODO nuova di prova
  checkIfAWizardIsSaved() {
    this.disable.generaCouponPreview = true;
    this.disablingSavingWizardState = false;

    if (this.messageInstanceObject.messageInstanceRule) {
      this.messageInstanceObject.messageInstanceRule.forEach(el => {
        if (el.ruleType == "WZ") {
          this.disable.generaCouponPreview = false;
          this.disablingSavingWizardState = true;
        }
      });
    }

    // Aggiunta: se nessun tp è certifier → abilita preview, blocca salvataggio
    const hasCertifierTp = this.touchPointEmission.some(function (tp) {
      return tp && tp.certifier === this.srvCampaign3.touchpointCertifier.YES;
    }.bind(this));

    if (!hasCertifierTp) {
      this.disable.generaCouponPreview = false;
      this.disablingSavingWizardState = true;
    }
  }
  ///newthings
  wizardList: Array<Campaign3Wizard> = [];
  currentInfo = {
    type: null,
    touchpointSelected: null,
    offline_online: null
  }

  //TODO in test: 1686
  onWizardSelected(wizard: any) {
    let selectedTouch = this.currentInfo.touchpointSelected;
    let touchType = this.currentInfo.type;



    if (touchType == 'E') {
      let index = this.touchPointEmission.findIndex(el =>
        el.ochannel_id === selectedTouch.ochannel_id &&
        el.code === selectedTouch.code &&
        el.layout_id === selectedTouch.layout_id
      );

      if (index !== -1) {
        // Sostituisci l'elemento nell'array
        this.touchPointEmission[index].wizardModel = wizard;
        console.log("Touchpoint aggiornato:", this.touchPointEmission[index]);
      } else {
        console.log("Nessun touchpoint selezionato corrisponde");
      }


    }



    //dal touchpoint determino se è fruition o emission

    //this.touchpoints[this.currentInfo.type][this.currentInfo.offline_online][this.currentInfo.index].wizardModel = Object.assign({},wizard);
    this.show.modalWizard = false;
  }

  onClickAnnulla_ModalWizard() {
    this.resetCurrentInfo();
    this.show.modalWizard = false;
  }
  resetCurrentInfo() {
    this.currentInfo.type = null;
    this.currentInfo.offline_online = null;
    this.currentInfo.touchpointSelected = null;
  }

  onClickSearchWizard(type: string, touchpoint: Touchpoint, index: number) {
    let offline_online = touchpoint.flg_offline == "1" ? 'OFF' : 'ON';
    this.setCurrentInfo(type, offline_online, touchpoint);
    this.wizardList = touchpoint.wizardList;
    this.show.modalWizard = true;
  }
  setCurrentInfo(type: string, offline_online: string, touchpoint: Touchpoint) {
    this.currentInfo.type = type;
    this.currentInfo.offline_online = offline_online;
    this.currentInfo.touchpointSelected = touchpoint;
  }


  //TODO: adattare  notifiche a messaggi non a coupon!
  onClickPubblicaNuovamente() {
    //this.srvNotify.add({severity: 'info', summary: 'Info', detail: 'Funzione temporaneamente non abilitata! Work in progress...'});
    if (this.messageInstanceObject.status == "P" || this.messageInstanceObject.status == "?") {

      let publishable = this.certificationInfo.needsCertification ? (this.certificationInfo.isCertificated == true ? true : false) : false;

      var self = this;
      console.log(publishable);

      //cambiare con la nuova chiamata
      this.srvCampaign3.publish(this.campaignInfo.id, this.messageInstanceObject.id, publishable).subscribe(res => {
        if (res) {
          self.srvNotify.add({
            severity: 'success',
            summary: this.translate.instant('common.success'),
            detail: this.translate.instant('campaign.final_coupon_generation_successful')
          });
        } else {
          self.srvNotify.add({
            severity: 'error',
            summary: this.translate.instant('common.error'),
            detail: this.translate.instant('campaign.error_final_coupon_generation')
          });
        }

        self.reloadStatusData();
      });

    }
    else {

      self.srvNotify.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('campaign.no_conditions_to_publish_promo')
      });


    }
  }


}




// WEBPACK FOOTER //
// ./src/app/views/campaing-3-message/message-3-validations/message-3-validations.component.ts